import {styled} from "@mui/system";
import {Box, Typography} from "@mui/material";

export const HistoryTitle = styled(Typography)({
    color: "var(--brand-text-default)",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    letterSpacing: "0.15px",
})

export const HistoryElement = styled(Box)({
    display: "flex",
    alignItems: "center",
    gap: "16px",
    alignSelf: "stretch",
    flexDirection: "column"
})

export const HistoryElementHeadline = styled(Typography)({
    alignSelf: "stretch",
    color: "var(--grey-grey-06)",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0.1px",
})

export const HistoryElementContent = styled(Typography)({
    alignSelf: "stretch",
    color: "var(--grey-grey-14)",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
})

export const HistoryWrapper = styled(Box)({
    display: "flex",
    padding: "24px 32px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    flex: "1 0 0",
    alignSelf: "stretch",
})
